import { render, staticRenderFns } from "./ICareBpjs.vue?vue&type=template&id=388344f6"
import script from "./ICareBpjs.vue?vue&type=script&lang=js"
export * from "./ICareBpjs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports